import React from 'react';
import PropTypes from 'prop-types';

const noop = () => {};

function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}

function Repeat({ as, dummy, times, callback, children }) {
  let Tag = as;
  let cb = cbToCb(callback);
  let items = [...Array(times).keys()].map(i => children({ i, cb }));
  if (dummy) return <>{items} </>;
  return <Tag>{items}</Tag>;
}

export default Repeat;

Repeat.propTypes = {
  as: PropTypes.string.isRequired,
  times: PropTypes.number.isRequired,
  // children: PropTypes.node,
  cb: PropTypes.func,
};

Repeat.defaultProps = {
  as: 'ol',
  times: 10,
  cb: noop(),
};
